import { create } from "zustand";
import { AppointmentHistory } from "../components/interfaces";

interface AppointmentHistoryStore {
  appointments: AppointmentHistory[];
  appointmentsFetched: boolean;
  setAppointmentsFetched: (value: boolean) => void;
  updateAppointments: (results: AppointmentHistory[]) => void;
  clearAppointments: () => void;
}

export const useAppointmentStore = create<AppointmentHistoryStore>()((set) => ({
  appointments: [],
  appointmentsFetched: false,
  setAppointmentsFetched: (value: boolean) =>
    set({ appointmentsFetched: value }),
  updateAppointments: (data) =>
    set((state) => ({
      appointments: [...state.appointments, ...data],
    })),
  clearAppointments: () => set({ appointments: [] }),
}));
